<template>
    <form class="admin-linear-form" @submit.prevent="proceed" @keydown="ipFilterForm.errors.clear($event.target.name)">
        <div class="admin-linear-form__grid">
            <div class="admin-linear-field">
                <label>{{trans('ip_filter.start_ip')}}</label>
                <input class="form-control" type="text" value="" v-model="ipFilterForm.start_ip" name="start_ip" :placeholder="trans('ip_filter.start_ip')">
                <show-error :form-name="ipFilterForm" prop-name="start_ip"></show-error>
            </div>
            <div class="admin-linear-field">
                <label>{{trans('ip_filter.end_ip')}}</label>
                <input class="form-control" type="text" value="" v-model="ipFilterForm.end_ip" name="end_ip" :placeholder="trans('ip_filter.end_ip')">
                <show-error :form-name="ipFilterForm" prop-name="end_ip"></show-error>
            </div>
        </div>
        <div class="admin-linear-field">
            <label>{{trans('ip_filter.description')}}</label>
            <textarea class="form-control" type="text" value="" v-model="ipFilterForm.description" rows="3" name="description" :placeholder="trans('ip_filter.description')"></textarea>
            <show-error :form-name="ipFilterForm" prop-name="description"></show-error>
        </div>
        <div class="admin-linear-form__actions">
            <button type="button" class="btn btn-sm admin-form-btn-cancel" v-if="!id" @click="$emit('cancel')">
                {{trans('general.cancel')}}
            </button>
            <router-link to="/configuration/ip-filter" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" v-show="id">{{trans('general.cancel')}}</router-link>
            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">
                <span v-if="id">{{trans('general.update')}}</span>
                <span v-else>{{trans('general.save')}}</span>
            </button>
        </div>
    </form>
</template>


<script>
    export default {
        components: {},
        data() {
            return {
                ipFilterForm: new Form({
                    start_ip: '',
                    end_ip: '',
                    description: ''
                })
            };
        },
        props: ['id'],
        mounted() {
            if(this.id)
                this.getIpFilter();
        },
        methods: {
            proceed(){
                if(this.id)
                    this.updateIpFilter();
                else
                    this.storeIpFilter();
            },
            storeIpFilter(){
                this.ipFilterForm.post('/api/ip-filter')
                    .then(response => {
                        toastr.success(response.message);
                        this.$emit('completed');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getIpFilter(){
                axios.get('/api/ip-filter/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.ipFilterForm.start_ip = response.start_ip;
                        this.ipFilterForm.end_ip = response.end_ip;
                        this.ipFilterForm.description = response.description;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.$router.push('/configuration/ip-filter');
                    });
            },
            updateIpFilter(){
                this.ipFilterForm.patch('/api/ip-filter/'+this.id)
                    .then(response => {
                        toastr.success(response.message);
                        this.$router.push('/configuration/ip-filter');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>

<style scoped>
.admin-linear-form {
    display: grid;
    gap: 1rem;
}

.admin-linear-form__grid {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.admin-linear-field label {
    display: block;
    margin-bottom: 0.45rem;
    color: var(--dash-pro-text);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.admin-linear-form__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.65rem;
    padding-top: 0.35rem;
}

@media (max-width: 575.98px) {
    .admin-linear-form__grid {
        grid-template-columns: 1fr;
    }
}
</style>
